import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';

import { desktopBreakpoint, tabletBreakpoint } from 'common/responsive';

import { ProductSlider as ProductSliderModel } from 'models';
import Container from 'blocks/Container/Container';
import Carousel from 'blocks/Carousel/Carousel';
import Header4 from 'elements/Header4';
import { Row, Column } from 'hedron';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { safeHtmlWithBr } from 'common/methods/string';
import SlideWrapper from './SlideWrapper';
import ProductSlide from './ProductSlide';

const ProductSlider = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 750px;
    padding: 0;
`;

export default class ProductSliderBlock extends Component {
  static carouselSettings = {
    swipe: true,
    slidesToShow: 3.65,
    dots: false,
    infinite: false,
    arrows: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: desktopBreakpoint,
        settings: {
          slidesToShow: 1.99,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
        },
      },
      {
        breakpoint: tabletBreakpoint,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          arrows: false,
        },
      },
    ],
  };

  static propTypes = {
    data: PropTypes.instanceOf(ProductSliderModel).isRequired,
  };

  render() {
    const {
      data: {
        productSlides,
        header,
        htmlModifiers,
      },
    } = this.props;
    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
      >
        <Container>
          <Row>
            <Column lg={12}>
              <ProductSlider>
                <Header4
                  bold
                  dangerouslySetInnerHTML={{
                    __html: safeHtmlWithBr(header),
                  }}
                />
                <SlideWrapper>
                  <Carousel
                    settings={ProductSliderBlock.carouselSettings}
                  >
                    {productSlides.map((slide, index) => (
                      <ProductSlide
                        featureCard={slide}
                        key={slide.system.id}
                        index={index}
                      />
                    ))}
                  </Carousel>
                </SlideWrapper>
              </ProductSlider>
            </Column>
          </Row>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/ProductSlider/index.jsx